import BrandSetting from "dashboard/pages/brand/settings";
import IAMComponent from "dashboard/pages/brand/IAM";
import PageBuilder from "dashboard/pages/brand/PageBuilder";
import GlobalDesign from "dashboard/pages/brand/GlobalDesign";
import ContentLibrary from "dashboard/pages/brand/ContentLibrary";
import Enquiries from "dashboard/pages/brand/Enquiries";
import MailManager from "dashboard/pages/brand/MailManager";
import NftStudio from "dashboard/pages/brand/NftStudio";
import Ecommerce from "dashboard/pages/brand/Ecommerce";
import Bookings from "dashboard/pages/brand/Bookings";
import Billing from "dashboard/pages/brand/Billing";
import Tickets from "dashboard/pages/brand/Tickets";
import Accounting from "dashboard/pages/brand/Accounting";
import Audience from "dashboard/pages/brand/Audience";
import Orders from "dashboard/pages/brand/Orders";
import Discounts from "dashboard/pages/brand/Discounts";
import BrandOverview from "dashboard/pages/brand/Overview";
import ReviewsModeration from "dashboard/pages/brand/Reviews";
import Notifications from "dashboard/pages/brand/Notifications";
import Activity from "dashboard/pages/brand/Activity";
import Inbox from "dashboard/pages/brand/Inbox";
import Webhooks from "dashboard/pages/brand/Webhooks";
import LowStock from "dashboard/pages/brand/LowStock";
import ApiKeys from "dashboard/pages/brand/ApiKeys";
import Domains from "dashboard/pages/brand/Domains";
import BrandPayments from "dashboard/pages/brand/Payments";

const BrandPages = {};

BrandPages.BrandSetting = BrandSetting;
BrandPages.IAMComponent = IAMComponent;
BrandPages.PageBuilder = PageBuilder;
BrandPages.GlobalDesign = GlobalDesign;
BrandPages.ContentLibrary = ContentLibrary;
BrandPages.Enquiries = Enquiries;
BrandPages.MailManager = MailManager;
BrandPages.NftStudio = NftStudio;
BrandPages.Ecommerce = Ecommerce;
BrandPages.Bookings = Bookings;
BrandPages.Billing = Billing;
BrandPages.Accounting = Accounting;
BrandPages.Audience = Audience;
BrandPages.Orders = Orders;
BrandPages.Discounts = Discounts;
BrandPages.Overview = BrandOverview;
BrandPages.Reviews = ReviewsModeration;
BrandPages.Notifications = Notifications;
BrandPages.Activity = Activity;
BrandPages.Inbox = Inbox;
BrandPages.Webhooks = Webhooks;
BrandPages.LowStock = LowStock;
BrandPages.ApiKeys = ApiKeys;
BrandPages.Domains = Domains;
BrandPages.BrandPayments = BrandPayments;
BrandPages.Tickets = Tickets;

export default BrandPages;
